import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { BrandWordmark } from "@/components/Brand";

const LegalLayout = ({ title, subtitle, children }) => (
  <div className="min-h-screen bg-[#050816] text-white">
    <header className="border-b border-[#1dc7e9]/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-[80px] flex items-center justify-between">
        <Link to="/" className="flex items-center">
          <BrandWordmark className="h-14 sm:h-16 w-auto" />
        </Link>
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-[13px] text-[#b8c0cc] hover:text-white transition-colors"
        >
          <ArrowLeft size={14} />
          Voltar ao site
        </Link>
      </div>
    </header>

    <main className="relative">
      <div
        aria-hidden
        className="absolute -top-32 left-1/2 -translate-x-1/2 w-[800px] h-[400px] glow-radial opacity-40 pointer-events-none"
      />
      <div className="relative max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold leading-tight tracking-tight text-white text-balance">
          {title}
        </h1>
        <p className="mt-3 text-sm mono text-[#b8c0cc]">{subtitle}</p>

        <div className="mt-10 prose-doc text-[#b8c0cc] leading-relaxed text-[15px] space-y-5">
          {children}
        </div>

        <div className="mt-14 flex justify-center">
          <Link
            to="/"
            className="inline-flex items-center gap-2 border border-[#1dc7e9]/40 hover:bg-[#1dc7e9]/10 hover:border-[#1dc7e9]/70 text-white font-semibold text-sm px-6 py-3 rounded-lg transition-all duration-300"
            data-testid="legal-back-bottom"
          >
            <ArrowLeft size={14} />
            Voltar ao site
          </Link>
        </div>
      </div>
    </main>
  </div>
);

export const H2 = ({ children }) => (
  <h2 className="text-white font-bold text-xl sm:text-2xl tracking-tight mt-10 mb-3">
    {children}
  </h2>
);

export const P = ({ children }) => (
  <p className="text-[#b8c0cc] leading-relaxed">{children}</p>
);

export const UL = ({ children }) => (
  <ul className="list-disc pl-5 space-y-1.5 text-[#b8c0cc] marker:text-[#1dc7e9]/70">
    {children}
  </ul>
);

export const Strong = ({ children }) => (
  <span className="text-white font-semibold">{children}</span>
);

export default LegalLayout;
